import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Arende } from '../../interfaces/arende.interface';

@Injectable()
export class ArendeService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getArende(instance: string, id: string): Observable<Arende> {
    return this.http.get<Arende>(`${this.apiUrl}${instance}/arende/get/${id}`);
  }
}
